import { useEffect } from "react";
import PackingRoutes from "./routes/PackingRoutes";
import "cropperjs/dist/cropper.css";
// 

function App() {
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth", // Adds a smooth scrolling effect
    });
  }, [])
  return (
    <div className="bg-aths">
      <PackingRoutes />
    </div>
  );
}

export default App;
 